import { colorError, colorSuccess } from "@porsche-design-system/components-react/emotion"
import type { OfferStatus } from "@slfinrtl/ui-bff-routes"
import { defineMessages } from "react-intl"
import type { MessageDescriptor } from "react-intl"

const messages = defineMessages({
	statusOpen: {
		defaultMessage: "Open",
		id: "offer.status.open",
	},
	statusOpenTooltip: {
		defaultMessage: "The sale has not been reported yet.",
		id: "offer.status.openTooltip",
	},
	statusSaleReported: {
		defaultMessage: "Sale reported",
		id: "offer.status.saleReported",
	},
	statusSaleReportedTooltip: {
		defaultMessage: "The sale has been reported.",
		id: "offer.status.saleReportedTooltip",
	},
})

export type OfferStatusTagColor = "success" | "error"

export const statusToTagColorMap: Record<OfferStatus, OfferStatusTagColor> = {
	OPEN: "success",
	SALE_REPORTED: "error",
}

const tagColorToPdsColor: Record<OfferStatusTagColor, string> = {
	error: colorError,
	success: colorSuccess,
}

export const statusToColorMap: Record<OfferStatus, string> = {
	OPEN: tagColorToPdsColor[statusToTagColorMap.OPEN],
	SALE_REPORTED: tagColorToPdsColor[statusToTagColorMap.SALE_REPORTED],
}

export const statusToMessageMap: Record<OfferStatus, MessageDescriptor> = {
	OPEN: messages.statusOpen,
	SALE_REPORTED: messages.statusSaleReported,
}

export const statusToTooltipMessageMap: Record<OfferStatus, MessageDescriptor> = {
	OPEN: messages.statusOpenTooltip,
	SALE_REPORTED: messages.statusSaleReportedTooltip,
}
